<template>
    <div class="w" id="content">
        <div class="s_tl">
            <div class="left wov">
                当前位置：<a href="/">首页</a>
                <code class="lr3">&gt;</code>
                购物车
            </div>
        </div>
        <public-buying></public-buying>
        <public-hot-product></public-hot-product>
    </div>
</template>

<script>
import Public_buying from "@/components/car/buy_car"
import Public_hot_product from "@/components/common/hot-product"
export default {
    components:{
        'public-buying':Public_buying,
        'public-hot-product': Public_hot_product,
    },
    data(){
        return{
            num:1,
        }
    },
    methods:{

    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/car/middle_content.vue